import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import "@aws-amplify/ui-react/styles.css";

import NotFound from "./components/notFound";
import About from "./components/about";
import Contact from "./components/contact";
import Navbar from "./components/myNav";
import Home from "./components/home";
import Products from "./components/products";
import Services from "./components/services";
import Studio from "./components/Studio";
import RentOrGiveaway from "./components/mobileAppPolicyRentOrGiveAway";
import HTrackPrivacyPolicyrewr from "./components/iHTrackPrivacyPolicy";
import VoiceLoop from "./components/voiceLoop/VoiceLoop";
import SitePolicy from "./components/SitePolicy";
import TermsOfUse from "./components/TermsOfUse";

Amplify.configure(awsconfig);

function App() {
  return (
    <Router>
      <Navbar />
      <div className="container mt-4">
        <Routes>
          <Route path="*" element={<NotFound />} />{" "}
          {/* This is the catch-all route */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/voice-loop" element={<VoiceLoop />} />
          <Route path="/policy" element={<SitePolicy />} />
          <Route path="/terms" element={<TermsOfUse />} />
          {/* private section for app policy */}
          <Route
            path="/rentOrGiveaway82585dsf84"
            element={<RentOrGiveaway />}
          />
          <Route
            path="/iHTrackPrivacyPolicy6778sdf898"
            element={<HTrackPrivacyPolicyrewr />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
